
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { mockActivities } from "@/data/mockCustomerData";

interface CustomerActivitiesTabProps {
  customerId: string;
}

export function CustomerActivitiesTab({ customerId }: CustomerActivitiesTabProps) {
  const activities = mockActivities.filter(activity => activity.customerId === customerId);

  // Helper function to get appropriate icon class based on activity type
  const getActivityIcon = (type: string) => {
    switch(type) {
      case 'purchase':
        return 'bg-green-100 text-green-800';
      case 'referral':
        return 'bg-blue-100 text-blue-800';
      case 'login':
        return 'bg-purple-100 text-purple-800';
      case 'cashback_used':
        return 'bg-amber-100 text-amber-800';
      case 'wishlist':
        return 'bg-pink-100 text-pink-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Atividades Recentes</CardTitle>
        </CardHeader>
        <CardContent>
          {activities.length === 0 ? (
            <div className="text-center py-8 text-gray-500">
              Este cliente não possui atividades recentes.
            </div>
          ) : (
            <ul className="space-y-6">
              {activities.map((activity) => {
                const date = new Date(activity.date);
                return (
                  <li key={activity.id} className="relative flex gap-4">
                    <div className="relative mt-1 flex h-10 w-10 flex-none items-center justify-center rounded-full shadow-md shadow-muted/10">
                      <div className={`h-full w-full rounded-full ${getActivityIcon(activity.type)}`}></div>
                    </div>
                    <div className="flex-auto rounded-md p-3 ring-1 ring-inset ring-muted/10">
                      <div className="flex justify-between items-center gap-2">
                        <div className="font-medium">{activity.description}</div>
                        <time className="flex-none text-xs text-muted-foreground" dateTime={activity.date}>
                          {date.toLocaleDateString('pt-BR')} às {date.toLocaleTimeString('pt-BR').substring(0, 5)}
                        </time>
                      </div>
                      <p className="mt-1 text-sm text-muted-foreground">
                        {activity.type === 'purchase' && 'Compra realizada com sucesso.'}
                        {activity.type === 'referral' && 'Nova indicação registrada.'}
                        {activity.type === 'login' && 'Entrou na plataforma.'}
                        {activity.type === 'cashback_used' && 'Utilizou saldo de cashback em compra.'}
                        {activity.type === 'wishlist' && 'Adicionou item à lista de desejos.'}
                      </p>
                    </div>
                  </li>
                );
              })}
            </ul>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
